<header class="header">
    <div class="header__main">
        <div class="header__brand">
            @if (systemConfig.logo()) {
                <img class="header__logo" [src]="systemConfig.logo()" alt="" />
            }
            <h1 class="header__title">MELLÉKLETKEZELŐ</h1>
            @if (systemConfig.title()) {
                <span class="header__system-title">{{ systemConfig.title() }}</span>
            }
        </div>
        <div class="header__actions">
            @if (userService.userName()) {
                <span class="header__user">{{ userService.userName() }}</span>
            }
            @if (hasMatrix) {
                @if (!locked) {
                    <p-button label="MELLÉKLETEK ELLENŐRZÉSE" severity="secondary" [outlined]="true" size="small"
                        styleClass="header__btn--outline" (onClick)="validate.emit()" />
                }
                <p-button [label]="locked ? 'VISSZANYITÁS' : 'VÉGLEGESÍTÉS'"
                    [icon]="locked ? 'pi pi-lock-open' : 'pi pi-check'" iconPos="left" size="small"
                    styleClass="header__btn--primary" (onClick)="locked ? reopen.emit() : finalize.emit()" />
            }
        </div>
    </div>
</header>